'use client';

import clsx from 'clsx';
import Image from 'next/image';
import { useState } from 'react';

import LoadingSpinner from '@/app/components/ui/Loader/LoadingSpinner';
import type { ContentfulImage } from '@/app/types/contentful/types';

export default function BlogCoverImage({ coverImage }: { coverImage: ContentfulImage }) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="relative h-full w-full">
      {!isLoaded && (
        <div className="absolute inset-0 flex skeleton-loading items-center justify-center rounded-md border border-WHITE/20 bg-OFF-BLACK/50">
          <LoadingSpinner className="h-15 w-15" />
        </div>
      )}
      {coverImage.url ? (
        <Image
          src={coverImage.url}
          alt={coverImage.title || coverImage.description || 'Article Image'}
          width={coverImage.width}
          height={coverImage.height}
          onLoad={() => setIsLoaded(true)}
          title={coverImage.title || coverImage.description || 'Article Image'}
          className={clsx(
            'h-full w-full rounded-md transition-all duration-500 aspect-video object-cover',
            isLoaded ? 'opacity-100' : 'opacity-0',
          )}
        />
      ) : null}
    </div>
  );
}
